<template>
  <q-card
    class="relative-position full-height fm-checked-container fm-file-grid-item flex column justify-between no-wrap"
    :class="{'highlight': selectable, 'selected': selected, 'single-item-mode': singleItemMode}"
    style="word-wrap: break-word;"
    @click="$emit('clickedFile')"
  >
    <div class="cursor-pointer flex-auto">
      <q-avatar
        v-if="withPreview"
        :icon="!image ? icon : undefined"
        color="grey-3"
        text-color="grey-8"
        rounded
        font-size="3rem"
        style="width: 100%;"
        :style="{'height': previewHeight + 'px'}"
      >
        <q-img
          v-if="image"
          :src="image"
          style="height: 100%; width: 100%;"
          class="checkerboard rounded-borders"
          no-spinner
          @error="file.type = 'DOCUMENT'"
        />

        <slot name="avatar" />
      </q-avatar>

      <q-item class="q-px-sm">
        <q-item-section>
          <q-item-label
            :title="file.title || 'Unnamed File'"
            :class="{'opaque-60': !file.title}"
            class="text-ellipsis"
          >
            {{ file.title || 'Unnamed File' }}
          </q-item-label>
          <q-item-label
            :title="file.file_name"
            caption
            class="text-ellipsis"
          >
            {{ file.file_name }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </div>

    <q-tooltip
      v-if="withTooltip && !$q.platform.is.mobile"
      anchor="center right"
      self="center left"
      class="fm-file-tooltip"
      :delay="250"
    >
      <q-item-label v-if="fileSize">
        <span>File Size</span> {{ fileSize }}
      </q-item-label>
      <q-item-label v-if="file.file_extension">
        <span>File Type</span> {{ file.file_extension.toUpperCase() }}
      </q-item-label>
      <q-item-label v-if="file.created_at">
        <span>Created</span> {{ $formatSystemDate(file.created_at, luxonFormats.FRIENDLY_DATE_TIME) }}
      </q-item-label>
      <!-- Category may optionally be in the payload -->
      <q-item-label v-if="'category' in file">
        <span>Category</span> {{ file.category ? file.category.name : 'Home' }}
      </q-item-label>
      <q-item-label v-if="fileVisibility" class="q-pt-sm text-bold">
        {{ fileVisibility.label }}
      </q-item-label>
    </q-tooltip>

    <slot name="after" />
  </q-card>
</template>

<script>
import fileMixin from '../mixins/fileMixin'

export default {
  mixins: [fileMixin],
  props: {
    file: {
      required: true,
      type: Object
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    singleItemMode: {
      type: Boolean,
      default: false
    },
    withTooltip: {
      type: Boolean,
      default: false
    },
    withPreview: {
      type: Boolean,
      default: true
    },
    // Height of QAvatar file preview
    previewHeight: {
      type: Number,
      default: 120
    }
  },
  emits: ['clickedFile'],
  computed: {
    fileSize () {
      if (!this.file.total_file_size) {
        return 0
      }
      return this.getFilesize(this.file.total_file_size)
    },
    icon () {
      return this.getIcon(this.file.file_extension)
    },
    image () {
      return this.getNextAvailableImage(this.file)
    },
    fileVisibility () {
      return this.getVisiblityOptions(this.file.user).find(item => item.value === this.file.visibility)
    }
  }
}
</script>
